<template>
    <div class="menu-horizontal" :id="id">
        <div class="menu-horizontal-header">
            <div class="menu-horizontal-title">
                {{ title }}
            </div>
            <router-link :to="{ name: 'menu-single', params: { id } }" class="menu-horizontal-see-all">
                 {{ $t("pages.menu.blocks.categories.action") }}
            </router-link>
        </div>
        <ul class="menu-horizontal-ul">
            <MenuItemHorizontal v-for="item in items" :item="item" :key="item.id" />
        </ul>
    </div>

</template>

<script>
import MenuItemHorizontal from './MenuItemHorizontal.vue';

export default {
    name: "MenuHorizontalScroll",
    components: {
        MenuItemHorizontal,
    },
    props: {
        id: { type: String, required: true },
        title: { type: String, required: true },
        items: { type: Array, required: true },
    },
    data() {
        return {
        };
    },
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.menu-horizontal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 16px 22px;

    .menu-horizontal-title {
        font-weight: 590;
        font-size: 22px;
        line-height: 100%;

        color: black;
    }

    .menu-horizontal-see-all {
        font-weight: 510;
        font-size: 16px;
        line-height: 100%;
        text-align: end;

        color: $color_blue_cornflower;
    }
}

.menu-horizontal-ul {
    display: flex;
    gap: 10px;

    padding: 0 22px;

    overflow-x: auto;
    scrollbar-width: none;
}
</style>